import { gql } from 'apollo-boost';

export const RESYNC_ADMIN_ARTIFACT_DIAGNOSTIC = gql`
    mutation ResyncAdminArtifactDiagnostic($data: ResyncAdminArtifactDiagnosticInput!) {
        resyncAdminArtifactDiagnostic(data: $data) {
            ocrQueued
            messageId
            artifactCount
        }
    }
`;
